import React, { FC } from "react";
import { faStar } from "@fortawesome/pro-regular-svg-icons/faStar";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export const StarRegular: FC<Omit<FontAwesomeIconProps, "icon">> = (props) => (
  <FontAwesomeIcon icon={faStar} {...props} />
);
